import b1 from "./images/bl1.jpg";
import b2 from "./images/bl2.jpg";
import b3 from "./images/tm1.jpg";
import b4 from "./images/02.jpg";

export const blogImages = [b1, b2, b3, b4];

export const blogFilters = [
  { id: "all", label: "All Topics" },
  { id: "start", label: "Getting Started" },
  { id: "join", label: "Join & Verify" },
  { id: "funding", label: "Funding" },
  { id: "basics", label: "NGO Basics" },
  { id: "legal", label: "Legal & NRI" },
];

export const blogArticles = [
  {
    id: "start-ngo",
    category: "start",
    title: "How to Start an NGO in India?",
    answer:
      "To start an NGO in India, conduct thorough research, define your mission and objectives, register under the appropriate legal structure, obtain necessary licenses and permissions, and build a strong network of supporters and volunteers.",
  },
  {
    id: "register-ngo",
    category: "start",
    title: "How to Register NGO in India?",
    answer:
      "Registering an NGO involves choosing a suitable legal structure (Trust, Society, or Section 8 Company), preparing required documents, submitting the application to the appropriate authority, and fulfilling additional government requirements.",
  },
  {
    id: "form-ngo",
    category: "start",
    title: "How to Form an NGO in India",
    answer:
      "Forming an NGO requires careful planning, legal compliance, and community engagement — defining mission and objectives, selecting a legal structure, registering with relevant authorities, and establishing governance structures.",
  },
  {
    id: "open-ngo",
    category: "start",
    title: "How Can I Open NGO in India?",
    answer:
      "Opening an NGO in India involves fulfilling legal requirements, obtaining necessary approvals, defining a clear mission, and mobilizing resources effectively to establish a successful and impactful organization.",
  },
  {
    id: "process-start",
    category: "start",
    title: "What is the Process to Start NGO in India?",
    answer:
      "Assess community needs, choose an appropriate legal structure, register with authorities, establish governance and management systems, and begin your programs with transparency and accountability.",
  },
  {
    id: "process-register",
    category: "start",
    title: "What is the Process of NGO Registration in India?",
    answer:
      "The process varies by legal structure but generally involves document preparation, application submission to the relevant registrar, verification, and issuance of registration certificates upon approval.",
  },
  {
    id: "documents",
    category: "start",
    title: "What Documents Required for NGO Registration in India?",
    answer:
      "Typically required: identity and address proofs of founders, Memorandum of Association (MOA), Articles of Association (AOA), trust deed or society rules, and statutory declarations as per the chosen legal structure.",
  },
  {
    id: "start-pdf",
    category: "start",
    title: "How to Start an NGO in India PDF",
    answer:
      "Comprehensive PDF guides on starting an NGO are available online through government websites, nonprofit organizations, and legal advisory services — covering legal, procedural, and operational aspects.",
  },
  {
    id: "how-many",
    category: "basics",
    title: "How Many NGOs in India?",
    answer:
      "India is home to a large number of NGOs, with estimates ranging from several hundred thousand to over a million. The exact number varies due to new registrations, closures, and mergers.",
  },
  {
    id: "what-is-ngo",
    category: "basics",
    title: "What is NGO in India?",
    answer:
      "An NGO is an independent nonprofit organization that addresses social, economic, and environmental issues for public good, operating outside direct government control.",
  },
  {
    id: "meant-ngo",
    category: "basics",
    title: "What is Meant by NGO in India?",
    answer:
      "NGO stands for Non-Governmental Organization — a voluntary group with a social mission that works independently from the government to serve communities and promote welfare.",
  },
  {
    id: "work-ngo",
    category: "basics",
    title: "What is the Work of NGO in India?",
    answer:
      "NGOs undertake diverse activities including social services, education, healthcare, disaster relief, women empowerment, rural development, environmental conservation, and advocacy.",
  },
  {
    id: "does-ngo",
    category: "basics",
    title: "What Does NGO Do in India?",
    answer:
      "NGOs address social, economic, and environmental issues through community programs, awareness campaigns, direct aid, policy advocacy, and partnerships with government and private sectors.",
  },
  {
    id: "women-role",
    category: "basics",
    title: "Role of NGO in Improving Women's Condition in India",
    answer:
      "NGOs empower women through education, healthcare access, skill development, legal awareness, self-help groups, and advocacy for gender equality in rural and urban communities.",
  },
  {
    id: "when-started",
    category: "basics",
    title: "When NGO Started in India?",
    answer:
      "The modern NGO sector in India emerged during the colonial period and gained significant momentum after independence, growing into one of the world's largest civil society networks.",
  },
  {
    id: "biggest-ngo",
    category: "basics",
    title: "Which is the Biggest NGO in India?",
    answer:
      "There is no single largest NGO — size depends on scope, geographic reach, funding, and the sector served. Several organizations operate at national scale.",
  },
  {
    id: "best-ngo",
    category: "basics",
    title: "Which is the Best NGO in India?",
    answer:
      "The 'best' NGO is subjective and depends on mission alignment, effectiveness, transparency, and measurable impact in the community it serves.",
  },
  {
    id: "richest-ngo",
    category: "basics",
    title: "Which is the Richest NGO in India?",
    answer:
      "Wealth varies by revenue and assets. Several large NGOs have significant resources, but financial size alone does not measure social impact or effectiveness.",
  },
  {
    id: "why-needed",
    category: "basics",
    title: "Why NGO is Needed?",
    answer:
      "NGOs address social, economic, and environmental challenges that governments alone cannot fully cover, complementing public efforts and reaching underserved communities.",
  },
  {
    id: "why-ngo",
    category: "basics",
    title: "Why NGO?",
    answer:
      "NGOs are essential for social development, humanitarian causes, and promoting social justice — giving citizens a direct way to serve their communities.",
  },
  {
    id: "why-important",
    category: "basics",
    title: "Why Are NGOs Important?",
    answer:
      "NGOs address inequalities, promote human rights, foster civic engagement, and bring innovative solutions to local and national challenges.",
  },
  {
    id: "why-work",
    category: "basics",
    title: "Why Do You Want to Work in an NGO?",
    answer:
      "Working in an NGO offers the chance to make a meaningful impact, contribute to social change, develop new skills, and serve causes you deeply care about.",
  },
  {
    id: "join-ngo",
    category: "join",
    title: "How to Join NGO in India?",
    answer:
      "Research organizations aligned with your values, reach out to inquire about volunteer or employment opportunities, attend events and workshops, and actively participate in their activities.",
  },
  {
    id: "check-auth",
    category: "join",
    title: "How to Check Authenticity of NGO in India?",
    answer:
      "Verify registration with government authorities, review financial reports and annual returns, evaluate track record and reputation, and seek recommendations from trusted sources.",
  },
  {
    id: "get-funds",
    category: "funding",
    title: "How to Get Funds for NGO in India?",
    answer:
      "NGOs can raise funds through government grants, corporate sponsorships, individual donations, fundraising events, crowdfunding platforms, and organizational partnerships.",
  },
  {
    id: "raise-funds",
    category: "funding",
    title: "How to Raise Funds for NGO in India?",
    answer:
      "Diversify revenue streams, leverage social media and digital platforms, build donor relationships, and demonstrate transparency and accountability in financial management.",
  },
  {
    id: "nri-start",
    category: "legal",
    title: "Can NRI Start NGO in India?",
    answer:
      "Yes, NRIs can start an NGO in India by fulfilling legal requirements, complying with FCRA and registration regulations, and partnering with local representatives.",
  },
  {
    id: "foreigners-start",
    category: "legal",
    title: "Can Foreigners Start NGO in India?",
    answer:
      "Yes, foreigners can start an NGO by partnering with Indian citizens or residents, following FCRA guidelines, and complying with all registration and operational regulations.",
  },
  {
    id: "oci-start",
    category: "legal",
    title: "Can OCI Start NGO in India?",
    answer:
      "Yes, OCI cardholders can start an NGO by fulfilling legal requirements, appointing local representatives, and complying with applicable foreign contribution and registration rules.",
  },
];

export const featuredGuide = {
  title: "Exploring NGOs in India: A Comprehensive Guide",
  intro:
    "Are you curious about Non-Governmental Organizations in India and their impact on society? This guide covers formation, registration, funding, and the vital role NGOs play across communities.",
  sections: [
    {
      heading: "NGO Formation and Registration",
      text: "Starting an NGO involves defining your mission, choosing a legal structure (Trust, Society, or Section 8 Company), preparing documents, and obtaining registration from the appropriate authority.",
    },
    {
      heading: "NGOs Across Different Cities",
      text: "From Farrukhabad and Lucknow to Kanpur, NGOs provide educational support, disaster relief, and community development — serving people across Uttar Pradesh and beyond.",
    },
    {
      heading: "NGO Job & Volunteer Opportunities",
      text: "The NGO sector offers roles from entry-level volunteering to specialized program management. Reach out to local organizations like Nishwarthaprayas to begin your journey.",
    },
    {
      heading: "NGO Darpan Portal",
      text: "NGO Darpan is a government portal for registration and monitoring of NGOs in India, offering search, registration procedures, and compliance tracking.",
    },
    {
      heading: "Environmental Conservation",
      text: "Many NGOs lead initiatives in environmental conservation through community programs, partnerships, and sustainable development projects across India.",
    },
  ],
};
